import React from 'react';

function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header single">
          <h2>Çalışma Alanı</h2>
        </div>
        <div className="service-grid">
          <div className="service-copy">
            <h3>Psikoterapi Nedir?</h3>
            <p>
              Bireysel Psikoterapi, kişinin duygusal zorluklarını, düşünce kalıplarını ve yaşamsal
              sıkıntılarını terapist eşliğinde ele aldığı, bilimsel temellere dayanan bir ruh sağlığı
              hizmetidir. Bu süreçte birey; kendini, ilişkilerini ve yaşantılarını daha iyi anlamayı,
              içsel çatışmalarıyla başa çıkmayı ve daha doyumlu bir yaşam sürmeyi hedefler. Psikodinamik
              ve analitik yaklaşımlarda, bireysel psikoterapi sıklıkla kişinin geçmiş yaşantıları ve
              bilinçdışı süreçleriyle çalışır (Shedler, 2010).
            </p>
            <p>
              Psikoterapi süreci gizlilik ilkesine dayanır. Terapi odası, kişinin kendini
              yargılanmadan ifade edebileceği güvenli bir alan sunar. Görüşmeler karşılıklı saygı,
              sınırlar ve zaman çerçevesi içinde yürütülür.
            </p>
            <p>
              Psikoterapide aşağıdaki konular başta olmak üzere birçok alanda çalışmak mümkündür:
            </p>
            <ul className="service-list">
              <li>Kaygı bozuklukları (sosyal kaygı, panik atak, genel kaygı vb.)</li>
              <li>Depresyon ve duygu durum sorunları</li>
              <li>İlişki ve bağlanma problemleri</li>
              <li>Yas ve kayıp süreçleri</li>
              <li>Travmatik yaşantılar ve travma sonrası stres</li>
              <li>İçsel çatışmalar ve tekrarlayan yaşam döngüleri</li>
              <li>Öfke kontrolü ve duygusal regülasyon sorunları</li>
              <li>İş hayatı ve stresle baş etme</li>
              <li>Psikosomatik belirtiler</li>
            </ul>
          </div>
        </div>
        <div className="service-copy">
          <p>
            Psikoterapi süreci, kişinin ihtiyaçlarına göre şekillenir ve bu alanlarla sınırlı olmaksızın,
            bireyin yaşamını etkileyen her türlü ruhsal ve zihinsel süreçle çalışılabilir.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
